<template>
    <div class="c frame bg-primary c-offerte" v-if="hasCartItems">
        <div class="container">
            <div class="row">
                <div class="col-12 col-xl-8 offset-xl-2">
                    <div class="c-shoppingcart">
                        <div class="h2 c-shoppingcart__title">{{ $t('Offerte.Cart.Titel') }}</div>
                        <div class="c-shoppingcart__items">
                            <div class="c-shoppingcart__item" v-for="item in cartInfo.items" :key="getCartItemKey(item)">
                                <a :href="item.productUrl" class="c-shoppingcart__item--img" :title="item.name">
                                    <img v-if="item.image" :src="item.image + '?width=170&height=170'" class="img-fluid" loading="lazy" height="170" width="170" />
                                    <img v-else src="/Assets/Images/noimg.svg" alt="" width="170" height="170" loading="lazy" />
                                </a>
                                <div class="c-shoppingcart__item--specs">
                                    <a class="h3" :href="item.productUrl" :title="item.name">{{ item.name }}</a>
                                    <p v-if="item.ralColor != null">
                                        <strong>{{ $t('Product.RALkleur') }}:</strong> {{ item.ralColor }}
                                    </p>
                                    <p v-if="item.implementation != null">
                                        <strong>{{ $t('Product.Uitvoering') }}:</strong> {{ item.implementation }}
                                    </p>
                                    <p v-if="item.option != null">
                                        <strong>{{ $t('Product.Opties') }}:</strong> {{ item.option }}
                                    </p>
                                </div>
                                <div class="c-shoppingcart__item--controls">
                                    <button class="btn btn-icon" :class="{ disabled: item.qty === 1 }" @click="decreaseQty(item)" :title="$t('Offerte.Aantal.Minder')">
                                        <span class="sr-only">{{ $t('Offerte.Aantal.Minder') }}</span
                                        ><i class="far fa-minus"></i>
                                    </button>
                                    <div class="c-shoppingcart__item--amount">
                                        <span class="sr-only">{{ $t('Offerte.Aantal') }}: </span>
                                        <transition name="bounce" mode="out-in">
                                            <div :key="item.qty">{{ item.qty }}</div>
                                        </transition>
                                    </div>
                                    <button class="btn btn-icon" @click="increaseQty(item)" :title="$t('Offerte.Aantal.Meer')">
                                        <span class="sr-only">{{ $t('Offerte.Aantal.Meer') }}</span
                                        ><i class="far fa-plus"></i>
                                    </button>
                                    <button class="btn btn-icon btn-delete" @click="removeItem(item)" :title="$t('Offerte.Aantal.Verwijder')">
                                        <span class="sr-only">{{ $t('Offerte.Aantal.Verwijder') }}</span
                                        ><i class="far fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'offerteCart',
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            getCartInfo: 'getCartInfo',
            getCartItems: 'getCartItems'
        }),
        cartInfo() {
            // console.log(this.getCartInfo);
            return this.getCartInfo;
        },
        hasCartItems() {
            if (this.cartInfo.items.length > 0) {
                return true;
            }
            return false;
        }
    },
    methods: {
        ...mapMutations({
            decreaseItemQty: 'decreaseCartItemQty',
            increaseItemQty: 'increaseCartItemQty',
            removeCartItem: 'removeItem'
        }),
        decreaseQty(item) {
            // console.log(item);
            this.decreaseItemQty(item);
            this.updateDataField();
        },
        increaseQty(item) {
            // console.log(item);
            this.increaseItemQty(item);
            this.updateDataField();
        },
        removeItem(item) {
            this.removeCartItem(item);
            this.updateDataField();
        },
        updateDataField() {
            document.querySelector('.offerteproductdata textarea').value = JSON.stringify(this.getCartItems);
        },
        getCartItemKey(item) {
            const color = item.ralColor ? item.ralColor.replaceAll(' ', '_') : 'nocolor';
            const implementation = item.implementation ? item.implementation.replaceAll(' ', '_') : 'noimplementation';
            const option = item.option ? item.option.replaceAll(' ', '_') : 'nooption';
            return item.name + '_' + color + '_' + implementation + '_' + option;
        }
    },
    mounted() {
        this.updateDataField();
    },
    created() {
        this.lang = JSON.parse(localStorage.getItem('language'));
        this.$i18n.set(this.lang);
        this.$store.dispatch('setLanguage', this.lang).then(function() {});
    }
};
</script>
